/*
 * Javascript to show and hide cookie bar using localstorage
 */

/**
 * @description Shows the cookie bar
 */
function showCookieBar() {
  let cookieBar = document.getElementById("cookie-bar");
  
  // Check if the element exists before trying to change its style
  if (cookieBar) {
    cookieBar.style.display = "block";
  } else {
    console.warn("Cookie bar element not found in the DOM.");
  }
}

/**
 * @description Hides the Cookie bar and saves the value to localstorage
 */
function hideCookieBar() {
  localStorage.setItem("isCookieAccepteds", "yes");

  let cookieBar = document.getElementById("cookie-bar");
  if (cookieBar) {
    cookieBar.style.display = "none";
  }
}

/**
 * @description Checks the localstorage and shows Cookie bar based on it.
 */
function initializeCookieBar() {
  let isCookieAccepted = localStorage.getItem("isCookieAccepteds");
  if (isCookieAccepted === null) {
    localStorage.setItem("isCookieAccepteds", "no");
    showCookieBar();
  }
  if (isCookieAccepted === "no") {
    showCookieBar();
  }
}

// 1. Wait for the HTML to be fully loaded before running the initialization
document.addEventListener('DOMContentLoaded', initializeCookieBar);

// 2. Assigning values to window/document object
document.cb_hideCookieBar = hideCookieBar;